module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-76x76-57a1eb6b4addd1e8743a4b54ecc83ce5.png";